<div #mydiv></div>
<div [formGroup]="form" class="form-group">

  <div [ngSwitch]="input.controlType">
    <div *ngSwitchCase="'textbox'" class="row">
      <label class="col-lg-4 col-form-label font-bold" [attr.for]="input.key">{{input.label}}</label>
      <input class="col-lg-4 form-control" [formControlName]="input.key" [id]="input.key" [type]="input.type">
      <mat-error *ngIf="form.controls[this.input.key].errors?.required">&nbsp;&nbsp;* Campo obligatorio</mat-error>
    </div>

    <div *ngSwitchCase="'number'" class="row">
      <label class="col-lg-4 col-form-label font-bold" [attr.for]="input.key">{{input.label}}</label>
      <input class="col-lg-4 form-control" [formControlName]="input.key" [id]="input.key" [type]="input.type">
      <mat-error *ngIf="form.controls[this.input.key].errors?.required">&nbsp;&nbsp;* Campo obligatorio</mat-error>
    </div>

    <div *ngSwitchCase="'checkbox'" class="row">
      <label class="col-lg-4 col-form-label font-bold" [attr.for]="input.key">{{input.label}}</label>
      <p-checkbox [formControlName]="input.key" [id]="input.key" binary="true" inputId="binary"></p-checkbox>
      <mat-error *ngIf="form.controls[this.input.key].errors?.required">&nbsp;&nbsp;* Campo obligatorio</mat-error>
    </div>

    <div *ngSwitchCase="'dropdown'" class="row">
      <label class="col-lg-4 col-form-label font-bold" [attr.for]="input.key">{{input.label}}</label>
      <p-dropdown [options]="input.options" optionLabel="descripcion" filter="descripcion" 
                  (onChange)="onChange($event, input.key)" [(ngModel)]="id"
                  [showClear]="true" placeholder="Seleccione...">                  
      </p-dropdown>
      <input class="col-lg-4 form-control" [formControlName]="input.key" style="display:none">
      <mat-error *ngIf="form.controls[this.input.key].errors?.required">&nbsp;&nbsp;* Campo obligatorio</mat-error>
    </div>

    <div *ngSwitchCase="'date'" class="row">
      <label class="col-lg-4 col-form-label font-bold" [attr.for]="input.key">{{input.label}}</label>
      <p-calendar selectOtherMonths="true" [formControlName]="input.key" dateFormat="dd/mm/yy" 
                  [id]="input.key" ngDefaultControl>
      </p-calendar>
      <mat-error *ngIf="form.controls[this.input.key].errors?.required">&nbsp;&nbsp;* Campo obligatorio</mat-error>
    </div>

    <div *ngSwitchCase="'dateMonth'" class="row">
      <label class="col-lg-4 col-form-label font-bold" [attr.for]="input.key">{{input.label}}</label>
      <p-calendar selectOtherMonths="true" [formControlName]="input.key" view="month" 
                  dateFormat="mm/yy" [yearNavigator]="true" yearRange="1900:9999" 
                  [id]="input.key" ngDefaultControl>
      </p-calendar>
      <mat-error *ngIf="form.controls[this.input.key].errors?.required">&nbsp;&nbsp;* Campo obligatorio</mat-error>
    </div>
  </div>
</div>
